import { FunctionComponent } from 'react';
import { ProductIcon } from '../../../common/Product/ProductIcon/ProductIcon';
import { ProductIconList } from './ProductAccessListCell.styles';
import { ProductAccessStatus } from 'domain/product/enums';
import { ProductRegistration } from 'domain/product/interfaces';

interface ProductAccessListCellProps {
	productRegistrations: ProductRegistration[];
}

export const ProductAccessListCell: FunctionComponent<
	ProductAccessListCellProps
> = ({ productRegistrations }) => (
	<ProductIconList gap="sm" wrap="nowrap" align="center">
		{productRegistrations
			.filter((a) => a.accessStatus === ProductAccessStatus.Allowed)
			.map((productRegistration: ProductRegistration) => (
				<ProductIcon
					key={productRegistration.productId}
					productId={productRegistration.productId}
				/>
			))}
	</ProductIconList>
);
